import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Course email-invite API service (token accept flow), mirroring ParentApi.
 * Complements the code-based InviteApi: teachers invite students by email, and
 * invitees validate/accept/decline. All calls go through fetchWithAuth.
 */
const endeavorBase = `${DATA_SERVICE_BASE_URL}/api/endeavors`;
const inviteBase = `${DATA_SERVICE_BASE_URL}/api/course-invites`;

export const CourseInviteApi = {
  // ─── Teacher-facing ───────────────────────────────────────────────
  /** List pending email invitations for a course (CourseInvitationDTO[]). */
  getEndeavorInvites: async (endeavorId) =>
    fetchWithAuth(`${endeavorBase}/${endeavorId}/email-invites`, { method: 'GET' }),

  /** Revoke a pending invitation. */
  revokeInvite: async (inviteId) =>
    fetchWithAuth(`${inviteBase}/${inviteId}`, { method: 'DELETE' }),

  // ─── Invitee-facing ───────────────────────────────────────────────
  /** List the current user's pending course invitations. */
  getMyInvites: async () =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/course-invites`, { method: 'GET' }),

  /** Validate a pending invite token (preview). */
  validateInvite: async (token) =>
    fetchWithAuth(`${inviteBase}/${encodeURIComponent(token)}/validate`, { method: 'GET' }),

  /** Accept an invite by token (from the email link). */
  acceptInvite: async (token) =>
    fetchWithAuth(`${inviteBase}/accept`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    }),

  /** Decline an invite by token (from the email link). */
  declineInvite: async (token) =>
    fetchWithAuth(`${inviteBase}/decline`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    }),

  /** Accept a pending invite from the current user's own list (no token). */
  acceptInviteById: async (inviteId) =>
    fetchWithAuth(`${inviteBase}/${inviteId}/accept`, { method: 'POST' }),

  /** Decline a pending invite from the current user's own list (no token). */
  declineInviteById: async (inviteId) =>
    fetchWithAuth(`${inviteBase}/${inviteId}/decline`, { method: 'POST' }),
};
